import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import SetupProfile from './pages/SetupProfile';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Compose from './pages/Compose';
import Settings from './pages/Settings';
import Search from './pages/Search';
import GalaxyDetail from './pages/GalaxyDetail';
import Notifications from './pages/Notifications';
import ExploreGalaxies from './pages/ExploreGalaxies';
import Friends from './pages/Friends';
import Comments from './pages/Comments';
import EditProfile from './pages/EditProfile';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import NeuralPlanning from './pages/NeuralPlanning';

function Protected({ children }) {
  const { authUser, authLoading, needsSetup } = useApp();
  if (authLoading) return null;
  if (!authUser) return <Navigate to="/" replace />;
  if (needsSetup) return <Navigate to="/setup-profile" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/setup-profile" element={<SetupProfile />} />
            <Route path="/home" element={<Protected><Home /></Protected>} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/profile/edit" element={<Protected><EditProfile /></Protected>} />
            <Route path="/posts/:postId/comments" element={<Protected><Comments /></Protected>} />
            <Route path="/compose" element={<Protected><Compose /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/search" element={<Protected><Search /></Protected>} />
            <Route path="/friends" element={<Protected><Friends /></Protected>} />
            <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
            <Route path="/explore-galaxies" element={<Protected><ExploreGalaxies /></Protected>} />
            <Route path="/galaxies/:galaxyId" element={<Protected><GalaxyDetail /></Protected>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/neural-planning" element={<NeuralPlanning />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </AppProvider>
    </div>
  );
}

export default App;
